import VoiceOverText from '../../BionicUI/instruction/VoiceOverText';
import { FC, useRef, useState } from 'react';
import gsap from 'gsap';

interface WelcomeProps {
  onAnimComplete?: () => void;
}

const Welcome: FC<WelcomeProps> = ({ onAnimComplete }) => {
  const [currentLine, setCurrentLine] = useState<number>(1);
  const line1Ref = useRef<HTMLDivElement>(null);
  const line2Ref = useRef<HTMLDivElement>(null);

  return (
    <div className="grid relative place-content-center font-medium text-[30px]">
      {currentLine === 1 && (
        <div ref={line1Ref} className="h-fit">
          <VoiceOverText
            line={{
              text: 'Welcome to Ground Zero.',
              sound: 'intro/welcome-to-ground-zero.mp3',
            }}
            onAnimComplete={() => {
              gsap.to(line1Ref.current, {
                alpha: 0,
                duration: 1.2,
                ease: 'power1.out',
                onComplete: () => setCurrentLine(2),
              });
            }}
          />
        </div>
      )}
      {currentLine === 2 && (
        <div
          ref={line2Ref}
          className="text-center text-xl sm:text-3xl sm:text-left h-fit"
        >
          <VoiceOverText
            line={{
              text: 'The Virtuals pre-launchpad designed to build stronger, more durable projects.',
              sound: 'intro/the-virtuals-pre-launchpad.mp3',
            }}
            onAnimComplete={() => {
              gsap.to(line2Ref.current, {
                alpha: 0,
                duration: 1.2,
                ease: 'power1.out',
                onComplete: onAnimComplete,
              });
            }}
          />
        </div>
      )}
      {}
    </div>
  );
};

export default Welcome;
